import { OPTION_FIELD_TYPES } from './kyc-shared.js';

export function supportsOptions(type) {
  return OPTION_FIELD_TYPES.has(type);
}

export function addOptionToField(fields, localId, rawValue) {
  const value = String(rawValue || '').trim();
  if (!value) {
    return fields;
  }

  return fields.map((field) => {
    if (field.localId !== localId) {
      return field;
    }

    return {
      ...field,
      options: [...(Array.isArray(field.options) ? field.options : []), value],
    };
  });
}

export function updateFieldOption(fields, localId, optionIndex, value) {
  return fields.map((field) => {
    if (field.localId !== localId) {
      return field;
    }

    return {
      ...field,
      options: (Array.isArray(field.options) ? field.options : []).map((option, idx) => (idx === optionIndex ? value : option)),
    };
  });
}

export function removeFieldOption(fields, localId, optionIndex) {
  return fields.map((field) => {
    if (field.localId !== localId) {
      return field;
    }

    return {
      ...field,
      options: (Array.isArray(field.options) ? field.options : []).filter((_, idx) => idx !== optionIndex),
    };
  });
}
